import { useLocation, Link } from 'react-router-dom';
import { LanguageSelector } from '@/components/ui/LanguageSelector';
import { ThemeToggleCompact } from '@/components/ui/ThemeToggle';
import HeaderAuth from '@/components/auth/HeaderAuth';

export function ConditionalHeader() {
  const location = useLocation();
  const pathname = location.pathname;

  // Check if we're on the home page (any locale)
  // Match: /, /de, /de/, /en, /en/, etc.
  const isHomePage = pathname === '/' || /^\/[a-z]{2}(-[A-Z]{2})?\/?$/.test(pathname);

  // Don't show header on home page as it has its own
  if (isHomePage) return null;
  
  return (
    <header className="bg-[rgb(var(--background))] dark:bg-[rgb(var(--background-secondary))] shadow-sm dark:shadow-2xl border-b border-gray-200 dark:border-white/10 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img src="/claroclaim-two-color.svg" alt="Claroclaim Logo" className="h-8 w-auto dark:hidden" />
              <img src="/claoroclaim-white-color.svg" alt="Claroclaim Logo" className="h-8 w-auto hidden dark:block" />
            </Link>
          </div>
          <div className="flex items-center space-x-3 sm:space-x-4 md:space-x-6">
            <HeaderAuth />
            <LanguageSelector />
            <ThemeToggleCompact />
          </div>
        </div>
      </div>
    </header>
  );
}